import http from "@/axios/http-common";

export type BagianAskep = "perencanaan" | "implementasi" | "semua";

function print(register_id: string | number, bagian: BagianAskep = "semua") {
  window.open(
    `${http.getAPI()}/register/${register_id}/askep/pdf?bagian=${bagian}`,
    "_blank"
  );
}

export default { print };
